// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/hero.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

:root {
    /* Brand Colors */
    --color-primary: #162636;
    /* Deep Navy */
    --color-secondary: #f44336;
    /* Accent Red */
    --color-tertiary: #6e66a9;
    /* Muted Purple */

    /* Neutrals */
    --color-bg: #f5f6f8;
    /* Light Neutral */
    --color-surface: #ffffff;
    /* Cards / Panels */
    --color-text-dark: #1a1a1a;
    --color-text-light: #ffffff;
    --color-border: #d7d7e0;

    /* Typography */
    --font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    --font-size-base: 16px;
    --font-size-sm: 14px;
    --font-size-lg: 20px;
    --line-height-base: 1.6;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-bold: 600;

    /* Spacing Scale */
    --space-xs: 4px;
    --space-sm: 8px;
    --space-md: 16px;
    --space-lg: 24px;
    --space-xl: 32px;

    /* Radius + Shadows */
    --radius-sm: 4px;
    --radius-md: 8px;
    --radius-lg: 12px;

    --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.12);
    --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.10);
    --shadow-lg: 0 8px 20px rgba(0, 0, 0, 0.08);

    /* Transition */
    --transition-fast: 150ms ease;
    --transition-normal: 250ms ease;
}

html{
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

body {
    font-family: var(--font-family);
    background-color: var(--color-bg);
    color: var(--color-text-dark);
    line-height: var(--line-height-base);
    font-size: var(--font-size-base);
    display: flex;
    flex-direction: column;
    flex: 1;
}

.container{
    display: flex;
    flex: 1;
    flex-direction: column;
}

header{
    background-color: var(--color-primary);
    color: var(--color-text-light);
    padding: var(--space-md);
    display: flex;
    align-items: center;
}

header .logo{
    height: 50px;
    width: auto;
}

header .title{
    font-size: 1.5rem;
    margin-left: 10px;
    margin-right: auto;
}

header .navbar{
    display: flex;
    gap: var(--space-md);
}

header .navbar button{
    background-color: var(--color-tertiary);
    color: var(--color-text-light);
    border: none;
    padding: var(--space-sm) var(--space-md);
    cursor: pointer;
    border-radius: var(--radius-sm);
    font-size: var(--font-size-base);
    transition: var(--transition-normal);
}

header .navbar button:hover{
    background-color: var(--color-secondary);
}

header .navbar button:active{
    transform: scale(0.98);
}

.content{
    display: flex;
    flex: 1;
}

footer{
    background-color: var(--color-primary);
    color: var(--color-text-light);
    text-align: center;
    padding: var(--space-md);
}

#home-page {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 80vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
}

#home-page .card {
    background: var(--color-surface);
    padding: var(--space-lg) var(--space-xl);
    border-radius: var(--radius-md);
    text-align: center;
    box-shadow: var(--shadow-md);
}

#home-page .card h2 {
    font-weight: var(--font-weight-bold);
    margin-bottom: var(--space-sm);
}

#home-page .card p {
    margin-bottom: var(--space-md);
}

#home-page .card button {
    padding: var(--space-sm) var(--space-lg);
    border-radius: var(--radius-sm);
    background: var(--color-tertiary);
    color: var(--color-text-light);
    font-weight: var(--font-weight-medium);
    transition: var(--transition-fast);
    border: none;
}

#home-page .card button:hover {
    background: #4151ff;
}

#home-page .card button:active {
    transform: scale(0.97);
}

/* Application page */

#application-page {
    display: flex;
    flex: 1;
    gap: var(--space-md);
    padding: var(--space-md);
}

.sidebar {
    width: 230px;
    background: var(--color-surface);
    border-right: 1px solid var(--color-border);
    padding: var(--space-md);
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    box-shadow: var(--shadow-sm);
}

/* .project-item {
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: background var(--transition-fast);
}

.project-item:hover {
    background: var(--color-bg);
}

.project-item.active {
    background: var(--color-tertiary);
    color: var(--color-text-light);
    font-weight: var(--font-weight-medium);
} */

.project-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--radius-sm);
    cursor: pointer;
}

.project-item:hover {
    background: var(--color-bg);
}

.project-item.active {
    background: var(--color-tertiary);
    color: var(--color-text-light);
}

.project-delete-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    margin-left: var(--space-sm);
}

.project-item {
    cursor: pointer;
}

.project-delete-btn {
    cursor: pointer;
}

.main-content {
    flex: 1;
    background: var(--color-surface);
    padding: var(--space-lg);
    border-radius: var(--radius-md);
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    box-shadow: var(--shadow-sm);
}

.todo-card {
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
    padding: var(--space-md);
    display: flex;
    flex-direction: column;
    gap: var(--space-sm);
    transition: var(--transition-fast);
}

.todo-row {
    display: grid;
    grid-template-columns: minmax(120px, 1fr) auto auto auto auto auto;
    gap: var(--space-sm);
    align-items: center;
}

.todo-details {
    display: none;
    font-size: var(--font-size-sm);
    color: var(--color-text-dark);
    opacity: 0.9;
}

.todo-card.expanded .todo-details {
    display: block;
}

.todo-priority {
    font-size: var(--font-size-sm);
}

.todo-priority {
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-medium);
    padding: 4px 10px;
    border-radius: 999px;
    white-space: nowrap;
}

.priority-high {
    background: rgba(244, 67, 54, 0.15);
    color: #f44336;
}

.priority-medium {
    background: rgba(255, 152, 0, 0.18);
    color: #ff9800;
}

.priority-low {
    background: rgba(76, 175, 80, 0.18);
    color: #4caf50;
}

.todo-card.completed {
    opacity: 0.55;
    background: #fafafa;
}

.todo-card.completed .todo-title {
    color: #666;
}

.todo-card.completed .todo-priority {
    filter: grayscale(0.7);
}

.todo-card.overdue {
    border-left: 4px solid #f44336;
}

.add-project-btn {
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--radius-sm);
    border: 1px solid var(--color-border);
    background: var(--color-bg);
    cursor: pointer;
}

.add-todo-btn {
    padding: var(--space-sm) var(--space-md);
    border: 1px solid var(--color-border);
    background: var(--color-bg);
    border-radius: var(--radius-sm);
    cursor: pointer;
    margin-bottom: var(--space-md);
}

.todo-delete-btn {
    background: none;
    border: none;
    cursor: pointer;
    margin-left: var(--space-sm);
    font-size: 16px;
}

.todo-edit-btn,
.todo-delete-btn {
    opacity: 0.5;
    transition: opacity var(--transition-fast);
}

.todo-edit-btn:hover,
.todo-delete-btn:hover {
    opacity: 1;
}

#app-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: none;
    padding: var(--space-lg);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-lg);
    background: var(--color-surface);
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    min-width: 350px;
}

/* Center modal */
#app-modal::backdrop {
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(2px);
}

/* Form layout */
#app-modal form {
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
}

/* Inputs */
#app-modal input,
#app-modal textarea,
#app-modal select {
    padding: var(--space-sm);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-sm);
    font-size: var(--font-size-base);
}

/* Buttons row */
#app-modal form div {
    display: flex;
    justify-content: space-between;
    gap: var(--space-sm);
}

#app-modal button {
    padding: var(--space-sm) var(--space-md);
    border-radius: var(--radius-sm);
    border: none;
    cursor: pointer;
}

#app-modal button[type="submit"] {
    background: var(--color-tertiary);
    color: var(--color-text-light);
}

#app-modal button[type="button"] {
    background: var(--color-border);
    color: var(--color-text-dark);
}

#app-modal:not([open]) {
    display: none;
}

#app-modal textarea {
    resize: vertical;
    /* or 'none' if you prefer */
    min-height: 70px;
}

#app-modal input,
#app-modal select,
#app-modal textarea {
    width: 100%;
}

.project-rename-btn,
.project-delete-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    padding: 0 4px;
}

.project-rename-btn,
.project-delete-btn {
    opacity: 0.6;
}

.project-rename-btn:hover,
.project-delete-btn:hover {
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;IACzB,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;;IAEvB,eAAe;IACf,8DAA8D;IAC9D,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;;IAEvB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;;IAEhB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;;IAEjB,0CAA0C;IAC1C,0CAA0C;IAC1C,2CAA2C;;IAE3C,eAAe;IACf,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,6BAA6B;IAC7B,oCAAoC;IACpC,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,OAAO;IACP,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;IAC9B,YAAY;IACZ,wCAAwC;IACxC,eAAe;IACf,+BAA+B;IAC/B,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,OAAO;AACX;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,OAAO;IACP,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,yDAAkD;IAClD,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,+BAA+B;IAC/B,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,iCAAiC;IACjC,8BAA8B;IAC9B,sCAAsC;IACtC,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,OAAO;IACP,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,2CAA2C;IAC3C,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wCAAwC;IACxC,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,gCAAgC;IAChC,wBAAwB;IACxB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;IACrC,+BAA+B;IAC/B,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,kEAAkE;IAClE,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;IACtC,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,qCAAqC;IACrC,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;IACrC,2BAA2B;IAC3B,+BAA+B;IAC/B,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,wBAAwB;IACxB,+BAA+B;IAC/B,4BAA4B;IAC5B,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA,WAAW;AACX;;;IAGI,wBAAwB;IACxB,qCAAqC;IACrC,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,UAAU;AACd","sourcesContent":["*{\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n:root {\n    /* Brand Colors */\n    --color-primary: #162636;\n    /* Deep Navy */\n    --color-secondary: #f44336;\n    /* Accent Red */\n    --color-tertiary: #6e66a9;\n    /* Muted Purple */\n\n    /* Neutrals */\n    --color-bg: #f5f6f8;\n    /* Light Neutral */\n    --color-surface: #ffffff;\n    /* Cards / Panels */\n    --color-text-dark: #1a1a1a;\n    --color-text-light: #ffffff;\n    --color-border: #d7d7e0;\n\n    /* Typography */\n    --font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    --font-size-base: 16px;\n    --font-size-sm: 14px;\n    --font-size-lg: 20px;\n    --line-height-base: 1.6;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-bold: 600;\n\n    /* Spacing Scale */\n    --space-xs: 4px;\n    --space-sm: 8px;\n    --space-md: 16px;\n    --space-lg: 24px;\n    --space-xl: 32px;\n\n    /* Radius + Shadows */\n    --radius-sm: 4px;\n    --radius-md: 8px;\n    --radius-lg: 12px;\n\n    --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.12);\n    --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.10);\n    --shadow-lg: 0 8px 20px rgba(0, 0, 0, 0.08);\n\n    /* Transition */\n    --transition-fast: 150ms ease;\n    --transition-normal: 250ms ease;\n}\n\nhtml{\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n}\n\nbody {\n    font-family: var(--font-family);\n    background-color: var(--color-bg);\n    color: var(--color-text-dark);\n    line-height: var(--line-height-base);\n    font-size: var(--font-size-base);\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.container{\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n}\n\nheader{\n    background-color: var(--color-primary);\n    color: var(--color-text-light);\n    padding: var(--space-md);\n    display: flex;\n    align-items: center;\n}\n\nheader .logo{\n    height: 50px;\n    width: auto;\n}\n\nheader .title{\n    font-size: 1.5rem;\n    margin-left: 10px;\n    margin-right: auto;\n}\n\nheader .navbar{\n    display: flex;\n    gap: var(--space-md);\n}\n\nheader .navbar button{\n    background-color: var(--color-tertiary);\n    color: var(--color-text-light);\n    border: none;\n    padding: var(--space-sm) var(--space-md);\n    cursor: pointer;\n    border-radius: var(--radius-sm);\n    font-size: var(--font-size-base);\n    transition: var(--transition-normal);\n}\n\nheader .navbar button:hover{\n    background-color: var(--color-secondary);\n}\n\nheader .navbar button:active{\n    transform: scale(0.98);\n}\n\n.content{\n    display: flex;\n    flex: 1;\n}\n\nfooter{\n    background-color: var(--color-primary);\n    color: var(--color-text-light);\n    text-align: center;\n    padding: var(--space-md);\n}\n\n#home-page {\n    display: flex;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n    min-height: 80vh;\n    background-image: url('./assets/images/hero.webp');\n    background-size: cover;\n    background-position: center;\n}\n\n#home-page .card {\n    background: var(--color-surface);\n    padding: var(--space-lg) var(--space-xl);\n    border-radius: var(--radius-md);\n    text-align: center;\n    box-shadow: var(--shadow-md);\n}\n\n#home-page .card h2 {\n    font-weight: var(--font-weight-bold);\n    margin-bottom: var(--space-sm);\n}\n\n#home-page .card p {\n    margin-bottom: var(--space-md);\n}\n\n#home-page .card button {\n    padding: var(--space-sm) var(--space-lg);\n    border-radius: var(--radius-sm);\n    background: var(--color-tertiary);\n    color: var(--color-text-light);\n    font-weight: var(--font-weight-medium);\n    transition: var(--transition-fast);\n    border: none;\n}\n\n#home-page .card button:hover {\n    background: #4151ff;\n}\n\n#home-page .card button:active {\n    transform: scale(0.97);\n}\n\n/* Application page */\n\n#application-page {\n    display: flex;\n    flex: 1;\n    gap: var(--space-md);\n    padding: var(--space-md);\n}\n\n.sidebar {\n    width: 230px;\n    background: var(--color-surface);\n    border-right: 1px solid var(--color-border);\n    padding: var(--space-md);\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    box-shadow: var(--shadow-sm);\n}\n\n/* .project-item {\n    padding: var(--space-sm) var(--space-md);\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: background var(--transition-fast);\n}\n\n.project-item:hover {\n    background: var(--color-bg);\n}\n\n.project-item.active {\n    background: var(--color-tertiary);\n    color: var(--color-text-light);\n    font-weight: var(--font-weight-medium);\n} */\n\n.project-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--space-sm) var(--space-md);\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n}\n\n.project-item:hover {\n    background: var(--color-bg);\n}\n\n.project-item.active {\n    background: var(--color-tertiary);\n    color: var(--color-text-light);\n}\n\n.project-delete-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    margin-left: var(--space-sm);\n}\n\n.project-item {\n    cursor: pointer;\n}\n\n.project-delete-btn {\n    cursor: pointer;\n}\n\n.main-content {\n    flex: 1;\n    background: var(--color-surface);\n    padding: var(--space-lg);\n    border-radius: var(--radius-md);\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    box-shadow: var(--shadow-sm);\n}\n\n.todo-card {\n    border: 1px solid var(--color-border);\n    border-radius: var(--radius-md);\n    padding: var(--space-md);\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-sm);\n    transition: var(--transition-fast);\n}\n\n.todo-row {\n    display: grid;\n    grid-template-columns: minmax(120px, 1fr) auto auto auto auto auto;\n    gap: var(--space-sm);\n    align-items: center;\n}\n\n.todo-details {\n    display: none;\n    font-size: var(--font-size-sm);\n    color: var(--color-text-dark);\n    opacity: 0.9;\n}\n\n.todo-card.expanded .todo-details {\n    display: block;\n}\n\n.todo-priority {\n    font-size: var(--font-size-sm);\n}\n\n.todo-priority {\n    font-size: var(--font-size-sm);\n    font-weight: var(--font-weight-medium);\n    padding: 4px 10px;\n    border-radius: 999px;\n    white-space: nowrap;\n}\n\n.priority-high {\n    background: rgba(244, 67, 54, 0.15);\n    color: #f44336;\n}\n\n.priority-medium {\n    background: rgba(255, 152, 0, 0.18);\n    color: #ff9800;\n}\n\n.priority-low {\n    background: rgba(76, 175, 80, 0.18);\n    color: #4caf50;\n}\n\n.todo-card.completed {\n    opacity: 0.55;\n    background: #fafafa;\n}\n\n.todo-card.completed .todo-title {\n    color: #666;\n}\n\n.todo-card.completed .todo-priority {\n    filter: grayscale(0.7);\n}\n\n.todo-card.overdue {\n    border-left: 4px solid #f44336;\n}\n\n.add-project-btn {\n    padding: var(--space-sm) var(--space-md);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--color-border);\n    background: var(--color-bg);\n    cursor: pointer;\n}\n\n.add-todo-btn {\n    padding: var(--space-sm) var(--space-md);\n    border: 1px solid var(--color-border);\n    background: var(--color-bg);\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    margin-bottom: var(--space-md);\n}\n\n.todo-delete-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    margin-left: var(--space-sm);\n    font-size: 16px;\n}\n\n.todo-edit-btn,\n.todo-delete-btn {\n    opacity: 0.5;\n    transition: opacity var(--transition-fast);\n}\n\n.todo-edit-btn:hover,\n.todo-delete-btn:hover {\n    opacity: 1;\n}\n\n#app-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border: none;\n    padding: var(--space-lg);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-lg);\n    background: var(--color-surface);\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    min-width: 350px;\n}\n\n/* Center modal */\n#app-modal::backdrop {\n    background: rgba(0, 0, 0, 0.3);\n    backdrop-filter: blur(2px);\n}\n\n/* Form layout */\n#app-modal form {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n}\n\n/* Inputs */\n#app-modal input,\n#app-modal textarea,\n#app-modal select {\n    padding: var(--space-sm);\n    border: 1px solid var(--color-border);\n    border-radius: var(--radius-sm);\n    font-size: var(--font-size-base);\n}\n\n/* Buttons row */\n#app-modal form div {\n    display: flex;\n    justify-content: space-between;\n    gap: var(--space-sm);\n}\n\n#app-modal button {\n    padding: var(--space-sm) var(--space-md);\n    border-radius: var(--radius-sm);\n    border: none;\n    cursor: pointer;\n}\n\n#app-modal button[type=\"submit\"] {\n    background: var(--color-tertiary);\n    color: var(--color-text-light);\n}\n\n#app-modal button[type=\"button\"] {\n    background: var(--color-border);\n    color: var(--color-text-dark);\n}\n\n#app-modal:not([open]) {\n    display: none;\n}\n\n#app-modal textarea {\n    resize: vertical;\n    /* or 'none' if you prefer */\n    min-height: 70px;\n}\n\n#app-modal input,\n#app-modal select,\n#app-modal textarea {\n    width: 100%;\n}\n\n.project-rename-btn,\n.project-delete-btn {\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 0 4px;\n}\n\n.project-rename-btn,\n.project-delete-btn {\n    opacity: 0.6;\n}\n\n.project-rename-btn:hover,\n.project-delete-btn:hover {\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
